import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemButton,
    Divider,
    ListItemText,
    TextField,
    Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery, useTheme } from "@mui/material";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@mui/material/IconButton";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import DeleteIcon from '@mui/icons-material/Delete';
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { errorNotify, successNotify } from "../../util/functions";
import { addCategorie, deleteCategorie } from "../../store/siteWebSlice";

const useStyles = makeStyles((theme: any) => ({
    dialogRoot: {
        position: "relative",
    },
    dialogTitleRoot: {
        "& .MuiTypography-h6": {
            fontSize: 16,
            color: theme.palette.common.dark,
        },
    },
    dialogActionsRoot: {
        padding: "16px 24px",
    },
}));



const BootstrapDialogTitle = (props: any) => {
    //Props
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#fff" }} {...other}>
            {children}
            <IconButton
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme: any) => theme.palette.grey[500],
                }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </DialogTitle>
    );
};

export default function CategorieDialog() {

    //redux
    const dispatch = useDispatch()
    const { categories } = useSelector((state: IReduxState) => state.siteWeb);

    //Hooks
    const theme = useTheme();
    const reduceWidth = useMediaQuery(theme.breakpoints.down("md"));
    const classes = useStyles();
    const [open, setOpen] = useState(false)

    const [state, setState] = useState("")
    const [loading, setLoading] = useState(false)
    const handleCancel = () => {
        setOpen(false);
    };

    const handleOpenDialog = () => {
        setOpen(true);
    };

    //Enregistrer une fontion
    const handleSave = async (e: any) => {
        try {
            e.preventDefault()
            setLoading(true)
            const apiPayload = {
                libCategorie: state
            }
            const res: any = await apiClient.post(SITEWEB_SERVER_BASE_URL, "/ajoutercategorie", apiPayload);
            if (res.status === 1) {
                dispatch(addCategorie(res.data))
                successNotify("Action effectuée avec succès");
                setLoading(false)
                setState("")
            } else {
                errorNotify("Erreur");
                setLoading(false)
            }
        } catch (error) {
            console.log("🚀 ~ file: Add.tsx:106 ~ handleSave ~ error:", error)
        }
    }

    //supprimer une categorie
    const handleDelete = async (e: any, item: any) => {
        try {
            e.preventDefault()
            setLoading(true)
            const apiPayload = {
                idCategorie: item.idCategorie
            }
            const res: any = await apiClient.post(SITEWEB_SERVER_BASE_URL, "/supprimercategorie", apiPayload);
            if (res.status === 1) {
                dispatch(deleteCategorie(res.data))
                successNotify("Action effectuée avec succès");
                setLoading(false)
                setState("")
            } else {
                errorNotify("Erreur");
                setLoading(false)
            }
        } catch (error) {
            console.log("🚀 ~ file: Add.tsx:106 ~ handleSave ~ error:", error)
        }
    }



    return (
        <>
            <Box sx={{ flexGrow: 1, width: "100%" }}>
                <IconButton
                    onClick={handleOpenDialog}
                >
                    <AddIcon color='info' />
                </IconButton>

            </Box>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth={true}
                style={{
                    userSelect: "none", // empêcher la selection du texte sur l'interface utilisateur de l'application
                }}
            >
                <Box component="form">
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleCancel}
                    >
                        <Typography variant="h6">Catégorie</Typography>
                    </BootstrapDialogTitle>
                    <DialogContent
                        dividers
                        style={{
                            // padding: reduceWidth ? "10px 10px" : "30px 45px",
                            height: "60vh",
                            background: "#f4f4f7",
                        }}
                    >
                        <Box sx={{ flexGrow: 1, width: "100%" }}>
                            <Grid
                                container
                                spacing={2}
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                            >
                                <Grid item md={10} xs={12} sm={10}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="categorie"
                                        label="Catégorie"
                                        value={state}
                                        onChange={(e: any) => setState(e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={2} xs={12} sm={2}>
                                    <Button
                                        // startIcon={<AddIcon />}
                                        variant="outlined"
                                        size="medium"
                                        disabled={loading}
                                        onClick={handleSave}
                                    >
                                        Enregistrer
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider style={{ marginTop: 10, marginBottom: 20 }} />
                        <Box sx={{ flexGrow: 1, width: "100%" }}>
                            <List dense={true}>
                                {categories.map((item, i: number) => {
                                    return (
                                        <div key={i}>
                                            <ListItem
                                                secondaryAction={
                                                    <IconButton
                                                        onClick={(e: any) => handleDelete(e, item)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                }
                                            >
                                                <ListItem>
                                                    <ListItemText
                                                        primary={item.libCategorie}
                                                    />
                                                </ListItem>
                                            </ListItem>
                                            <Divider />
                                        </div>
                                    );
                                })}
                            </List>
                        </Box>
                    </DialogContent>
                </Box>
            </Dialog>
        </>
    );
}
